import { useEffect, useState, useRef } from 'react';
import { Link } from 'react-router-dom';
import styles from './index.module.scss';
// import { toast, ToastContainer } from 'react-toastify';
// import { Loader2 } from 'lucide-react';
import AnalyticsService from '../../services/AnalyticsService';

const GOOGLE_PLAY_URL = 'https://play.google.com/store/apps/details?id=com.lumida.ai';
const TESTFLIGHT_URL = 'https://apps.apple.com/app/id6753766251';
const SCREEN_NAME = 'landing_page';
const REGCF_URL = 'https://republic.com/lumida-wealth?utm_source=lumidainvest.com&utm_medium=website&utm_campaign=reg-cf-raise&utm_content=green-banner';
const REGCF_BANNER_TEXT = 'Lumida Wealth is officially open for investment! Join our funding round and own a piece of the Investing SuperApp';

const featureSections = [
    {
    features: [
      { title: <>Stay Ahead With<br/>The Live News Feed</>, image: '/Home-21.webp' },
      { title: <>See The Stories<br/>Driving Market</>, image: '/Home-14.webp' },
      { title: <>Spot Risks Before They<br/>Become Problems</>, image: '/Home-7.webp' },
    ],
    showCTA: false,
  },
    {
    features: [
      { title: <>Find Tax Loss Harvests<br/>You Can Use</>, image: '/Home-18.webp' },
      { title: <>Uncover Your Portfolio's<br/>Thematic Exposure</>, image: '/Home-16.webp' },
      { title: <>See Why Your Portfolio<br/>Is Leading Or Lagging</>, image: '/Home-17.webp' },
    ],
    showCTA: true,
  },
  {
    features: [
      { title: <>Highest Conviction<br/>Ideas Of The Day</>, image: '/Home-2.webp' },
      { title: <>Fast Perspective,<br/>Deep Analysis</>, image: '/Home-4.webp' },
      { title: <>Find the Alpha<br/>In The Transcripts</>, image: '/Home-3.webp' },
    ],
    showCTA: false,
  },
      {
    features: [
      { title: <>Front Run The<br/>Whales</>, image: '/Home-22.webp' },
      { title: <>Invest Alongside<br/>Politicians</>, image: '/Home-23.webp' },
      { title: <>Uncover Insider Trading<br/>Insights In Minutes</>, image: '/Home-24.webp' },
    ],
    showCTA: true,
  },
  {
    features: [
      { title: <>Spot Themes Before<br/>They Trend</>, image: '/Home-6.webp' },
      { title: <>Track Ideas From The<br/>World's Best Investors</>, image: '/Home-5.webp' },
      { title: <>Get Real-Time<br/> Trump Signals</>, image: '/Home-9.webp' },
    ],
    showCTA: false,
  },
  {
    features: [
      { title: <>Get Technical Analysis<br/>on Digital Assets</>, image: '/Home-10.webp' },      
      { title: <>Spot Crypto Market<br/>Before It Spills Over</>, image: '/Home-15.webp' },
      { title: <>Breakdown Crypto<br/>Markets</>, image: '/Home-11.webp' },
    ],
    showCTA: true,
  },
  {
    features: [
      { title: <>Highlights<br/>Worth Hearing</>, image: '/Home-12.webp' },
      { title: <>Follow The KOLs<br/>Who Move Markets</>, image: '/Home-25.webp' },
      { title: <>Access The Deal Most<br/>Investors Never See</>, image: '/Home-13.webp' },
    ],
    showCTA: true,
  },
  
];

const DownloadCTA = ({ onTestFlightClick, onGooglePlayClick }) => (
  <div className={styles.ctaRow}>
    <a
      href={TESTFLIGHT_URL}
      target="_blank"
      rel="noopener noreferrer"
      className={styles.storeBadge}
      aria-label="Available on TestFlight"
      onClick={onTestFlightClick}
    >
      <img src="/appstore.png" alt="Available on AppStore" />
    </a>
    <a
      href={GOOGLE_PLAY_URL}
      target="_blank"
      rel="noopener noreferrer"
      className={styles.storeBadge}
      aria-label="Get it on Google Play"
      onClick={onGooglePlayClick}
    >
      <img src="/google-play.webp" alt="Get it on Google Play" />
    </a>
    <div className={styles.ctaDivider} />
    <span className={styles.ctaText}>Download The App Now</span>
  </div>
);

const SocialProof = () => (
  <div className={styles.socialProof}>
    <img src="/community.webp" alt="Community" className={styles.communityImg} />
    <span>Join 500+ others experiencing the Investing SuperApp - Powered by AI</span>
  </div>
);

const HomePage = () => {
  const [showStickyCta, setShowStickyCta] = useState(false);
  const heroRef = useRef(null);

  // const [email, setEmail] = useState('');
  // const [isSubmitting, setIsSubmitting] = useState(false);
  // const [waitlistSubmitted, setWaitlistSubmitted] = useState(false);
  // const downloadButtonsRef = useRef(null);

  // const submitWaitlist = async () => {
  //   try {
  //     setIsSubmitting(true);
  //     if (email.trim() === '') {
  //       toast.error('Please enter your email address');
  //       return;
  //     }
  //     const response = await fetch(`${import.meta.env.VITE_API_BASE_URL}/auth/join-waitlist`, {
  //       method: 'POST',
  //       body: JSON.stringify({ email }),
  //     });
  //     const result = await response.json();
  //     if (!response.ok) {
  //       toast.error(result.error);
  //     } else {
  //       toast.success('Successfully submitted waitlist.');
  //       setWaitlistSubmitted(true);
  //       if (typeof document !== 'undefined') document.activeElement?.blur();
  //       setTimeout(() => {
  //         downloadButtonsRef.current?.scrollIntoView({ behavior: 'smooth', block: 'center' });
  //       }, 400);
  //     }
  //   } catch (error) {
  //     console.error('Error submitting waitlist:', error);
  //     toast.error('Failed to submit waitlist. Please try again.');
  //   } finally {
  //     setEmail('');
  //     setIsSubmitting(false);
  //   }
  // };

  useEffect(() => {
    AnalyticsService.trackScreenView(SCREEN_NAME);
    return () => {
      AnalyticsService.trackScreenExit(SCREEN_NAME);
    };
  }, []);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        setShowStickyCta(!entry.isIntersecting);
      },
      { threshold: 0 }
    );
    if (heroRef.current) {
      observer.observe(heroRef.current);
    }
    return () => observer.disconnect();
  }, []);

  const handleTestFlightClick = () => {
    AnalyticsService.trackButtonClick('testflight_download', { url: TESTFLIGHT_URL });
  };

  const handleGooglePlayClick = () => {
    AnalyticsService.trackButtonClick('google_play_download', { url: GOOGLE_PLAY_URL });
  };

  const handleBannerClick = () => {
    AnalyticsService.trackButtonClick('regcf_banner', { url: REGCF_URL, text: REGCF_BANNER_TEXT });
  };

  return (
    <div className={styles.homepage}>
      {/* <ToastContainer position="top-right" autoClose={3000} theme="dark" /> */}

      {/* Announcement Banner */}
      {/* <a
        href={REGCF_URL}
        target="_blank"
        rel="noopener noreferrer"
        className={styles.announcementBanner}
        onClick={handleBannerClick}
      >
        <span className={styles.bannerText}>
          {REGCF_BANNER_TEXT}
          <svg className={styles.bannerChevron} width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M9 18L15 12L9 6" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
          </svg>
        </span>
      </a> */}

      {/* Waitlist CTA Section */}
      {/* <div className={styles.waitlistSection}>
        <p className={styles.waitlistDescription}>Be among the first to experience the Investing SuperApp - Powered by AI</p>
        <div className={styles.waitlistForm}>
          <input
            type="email"
            placeholder="Enter Your Email Address"
            className={styles.emailInput}
            onChange={(e) => setEmail(e.target.value)}
            value={email}
          />
          <button className={styles.joinButton} onClick={submitWaitlist} disabled={isSubmitting}>
            {isSubmitting ? (
              <Loader2 className={styles.loader} />
            ) : (
              'Join waitlist'
            )}
            <span className={styles.arrow}>→</span>
          </button>
        </div>
      </div> */}

      {/* Hero Section */}
      <section className={styles.hero} ref={heroRef}>
        <div className={styles.heroContent}>
          <div className={styles.heroText}>
            <h1>
              Trade Smarter,
              <br />
              Not Harder.
            </h1>
            <div className={styles.heroBadges}>
              <a
                href={TESTFLIGHT_URL}
                target="_blank"
                rel="noopener noreferrer"
                className={styles.heroBadge}
                aria-label="Available on TestFlight"
                onClick={handleTestFlightClick}
              >
                <img src="/appstore-glow.png" alt="Available on AppStore" />
              </a>
              <a
                href={GOOGLE_PLAY_URL}
                target="_blank"
                rel="noopener noreferrer"
                className={styles.heroBadge}
                aria-label="Get it on Google Play"
                onClick={handleGooglePlayClick}
              >
                <img src="/google-play-glow.webp" alt="Get it on Google Play" />
              </a>
            </div>
            <div className={styles.socialProofDesktop}>
              <SocialProof />
            </div>
          </div>
          <div className={styles.heroPhone}>
            <div className={styles.heroShape}></div>
            <img src="/Home-26.webp" alt="Lumida Invest Dark Mode" className={styles.heroPhoneBack} loading="eager" />
            <img src="/Home-20.webp" alt="Lumida Invest App" className={styles.heroPhoneFront} fetchPriority="high" />
          </div>
          <div className={styles.socialProofMobile}>
            <SocialProof />
          </div>
        </div>
      </section>

      {/* Feature Sections */}
      {featureSections.map((section, sectionIndex) => (
        <div key={sectionIndex}>
          <section
            className={`
                  ${styles.featureSection} 
                  ${sectionIndex % 2 === 0 ? styles.ellipseLeft : styles.ellipseRight}
                  ${sectionIndex % 2 === 0 ? styles.oddSection : styles.evenSection}
                `}
          >
            <div className={styles.bgEllipse} />
            <div className={styles.featureGrid}>
              {section.features.map((feature, featureIndex) => (
                <div key={featureIndex} className={styles.featureCard}>
                  <h3>{feature.title}</h3>
                  <div className={styles.phoneArea}>
                    <div className={styles.phoneGlow} />
                    <div className={styles.featureImageWrapper}>
                      <img src={feature.image} alt={feature.title} loading="lazy" decoding="async" />
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </section>
          {section.showCTA && (
            <DownloadCTA
              onTestFlightClick={handleTestFlightClick}
              onGooglePlayClick={handleGooglePlayClick}
            />
          )}
        </div>
      ))}

      {/* Bottom Social Proof */}
      <div className={styles.bottomProof}>
        <SocialProof />
      </div>

      {/* Mobile Sticky CTA */}
      <div className={`${styles.mobileStickyCta} ${showStickyCta ? styles.stickyVisible : ''}`}>
        <a
          href={TESTFLIGHT_URL}
          target="_blank"
          rel="noopener noreferrer"
          className={styles.heroBadge}
          aria-label="Available on TestFlight"
          onClick={handleTestFlightClick}
        >
          <img src="/appstore-glow.png" alt="Available on AppStore" />
        </a>
        <a
          href={GOOGLE_PLAY_URL}
          target="_blank"
          rel="noopener noreferrer"
          className={styles.heroBadge}
          aria-label="Get it on Google Play"
          onClick={handleGooglePlayClick}
        >
          <img src="/google-play-glow.webp" alt="Get it on Google Play" />
        </a>
      </div>

      {/* Footer */}
      <footer className={styles.footer}>
        <div className={styles.footerTop}>
          <div className={styles.footerLogo}>
            <img src="/Lumida-Invest-White-Logo.webp" alt="Lumida Invest" />
          </div>
          <div className={styles.footerRight}>
            <span className={styles.footerContact}>
              Contact: <a href="mailto:tech@lumida.com">tech@lumida.com</a>
            </span>
            <div className={styles.footerSocial}>
              <a href="https://www.linkedin.com/company/lumidawealth" target="_blank" rel="noopener noreferrer" aria-label="LinkedIn">
                <svg viewBox="0 0 24 24" fill="currentColor"><path d="M20.5 2h-17A1.5 1.5 0 002 3.5v17A1.5 1.5 0 003.5 22h17a1.5 1.5 0 001.5-1.5v-17A1.5 1.5 0 0020.5 2zM8 19H5v-9h3zM6.5 8.25A1.75 1.75 0 118.3 6.5a1.78 1.78 0 01-1.8 1.75zM19 19h-3v-4.74c0-1.42-.6-1.93-1.38-1.93A1.74 1.74 0 0013 14.19a.66.66 0 000 .14V19h-3v-9h2.9v1.3a3.11 3.11 0 012.7-1.4c1.55 0 3.36.86 3.36 3.66z" /></svg>
              </a>
              <a href="https://x.com/lumidawealth" target="_blank" rel="noopener noreferrer" aria-label="X">
                <svg viewBox="0 0 24 24" fill="currentColor"><path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z" /></svg>
              </a>
              <a href="https://facebook.com/lumidawealth" target="_blank" rel="noopener noreferrer" aria-label="Facebook">
                <svg viewBox="0 0 24 24" fill="currentColor"><path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z" /></svg>
              </a>
              <a href="https://instagram.com/lumidawealth" target="_blank" rel="noopener noreferrer" aria-label="Instagram">
                <svg viewBox="0 0 24 24" fill="currentColor"><path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zM12 0C8.741 0 8.333.014 7.053.072 2.695.272.273 2.69.073 7.052.014 8.333 0 8.741 0 12c0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98C8.333 23.986 8.741 24 12 24c3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98C15.668.014 15.259 0 12 0zm0 5.838a6.162 6.162 0 100 12.324 6.162 6.162 0 000-12.324zM12 16a4 4 0 110-8 4 4 0 010 8zm6.406-11.845a1.44 1.44 0 100 2.881 1.44 1.44 0 000-2.881z" /></svg>
              </a>
            </div>
          </div>
        </div>
        <div className={styles.footerBottom}>
          <p>Lumida Invest provides market insights and news for informational purposes only.</p>
          <p>
            &copy; 2026 Lumida Invest. All rights reserved.
            <span className={styles.footerDivider}>·</span>
            <Link to="/account-deletion" className={styles.footerSubtleLink}>Delete account</Link>
          </p>
        </div>
      </footer>
    </div>
  );
};

export default HomePage;
